import { useCallback, useRef } from 'react';

interface DocumentPreviewMap {
  files: string[];
  firstFile: string;
}

interface Props {
  valuesMap?:  Record<string, DocumentPreviewMap>;
}

const useGetFileUrl = ({ valuesMap }: Props) => {
  const fileUrlCache = useRef<Map<string, string>>(new Map());

  const getFileUrl = useCallback(
    (id?: string) => {
      if (id) {
        return valuesMap?.[id]?.firstFile || '';
      }
      return '';
    },
    [valuesMap]
  );

  const getStableFileUrl = useCallback((documentId?: string) => {
    if (!documentId) return '';
    if (fileUrlCache.current.has(documentId)) {
      return fileUrlCache.current.get(documentId)!;
    }
    const url = getFileUrl(documentId);
    if (url) {
      fileUrlCache.current.set(documentId, url);
    }
    return url;
  }, [getFileUrl]);

  return { getFileUrl, getStableFileUrl };
};

export default useGetFileUrl;
